export var translations = {
    "emd_player": {
        "stream_unavailable": {
            "title": "Stream currently unavailable",
            "msg" : "The requested stream is switched off or embedded code is invalid",
        },
        "config_changed": {
            "title": "Stream configuration changed",
            "msg"  : "Please updated the embedded code."
        },
        "server_notresp": {
            "title": "Server not responding",
            "msg"  : ""
        }
    }
}